import Widget from "Components/Common/Widget/Widget";
import React, { useState } from "react";
import { RxAvatar } from "react-icons/rx";
import { GrUserFemale } from "react-icons/gr";
import { LiaMaleSolid } from "react-icons/lia";
import { MdLock, MdPublic } from "react-icons/md";
import AvatarList from "Components/Avatar/AvatarList";

const Avatar = () => {
  const [counts, setCounts] = useState({
    totalAvatars: 0,
    maleAvatars: 0,
    femaleAvatars: 0,
    publicAvatars: 0,
    privateAvatars: 0,
  });
  const [filterType, setFilterType] = useState("all"); // "all" | "public" | "private"
  const [filterGender, setFilterGender] = useState(""); // "" | "male" | "female"

  return (
    <React.Fragment>
      <div className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        <Widget
          icon={<RxAvatar className="h-6 w-6" />}
          title={"Total Avatars"}
          subtitle={counts.totalAvatars.toString()}
        />
        <Widget
          icon={<LiaMaleSolid className="h-6 w-6 text-blue-500" />}
          title={"Male Avatars"}
          subtitle={counts.maleAvatars.toString()}
        />
        <Widget
          icon={<GrUserFemale className="h-6 w-6 text-pink-500" />}
          title={"Female Avatars"}
          subtitle={counts.femaleAvatars.toString()}
        />
        <Widget
          icon={<MdPublic className="h-6 w-6 text-emerald-500" />}
          title={"Public Avatars"}
          subtitle={counts.publicAvatars.toString()}
        />
        <Widget
          icon={<MdLock className="h-6 w-6 text-amber-500" />}
          title={"Private Avatars"}
          subtitle={counts.privateAvatars.toString()}
        />
      </div>

      <AvatarList
        onCountsUpdate={setCounts}
        filterType={filterType}
        setFilterType={setFilterType}
        filterGender={filterGender}
        setFilterGender={setFilterGender}
      />
    </React.Fragment>
  );
};

export default Avatar;
